// src/models/landing-page.js
import api from '../utils/contentful'

// We wrap the Contentful API client to format
// the response exactly the way we like it.
export default {
  async getProjects(contentType) {
    return await api.getEntries({
      content_type: contentType,
      order: 'fields.orderId'
    })
  }
}
